import { MultiTextField, getTranslatedText } from '@nile/components';
import {
  formatGroupLabel,
  formatOptionLabel,
  DropdownIndicator
} from '@nile/components/src/Pebbles/select';
import { TextField } from '@superops/ui-design-system';
import dayjs from 'dayjs';
import _, { isEmpty, debounce } from 'lodash';
import PropTypes from 'prop-types';
import React, { useState, useEffect } from 'react';
import DatePicker from 'react-datepicker';
import { injectIntl } from 'react-intl';
import Select from 'react-select';
import AsyncSelect from 'react-select/async';
import {
  reactSelectErrorStyles,
  reactSelectInlineError
} from '../../../Utils/style';

const ValueEditor = (props) => {
  const {
    operator,
    value,
    handleOnChange,
    title,
    className,
    type,
    inputType,
    values,
    async,
    errors,
    fetchValues,
    field,
    fieldData,
    intl,
    disabled = false,
    getValueGroupAccessor,
    getCustomGroupValueLabel
  } = props;
  let initialOptions = async ? [] : values;

  const fieldValueUnits = isEmpty(fieldData?.metricUnits)
    ? null
    : fieldData?.metricUnits?.map((el) => ({
        name: el,
        label: getTranslatedText(intl, `attribute.unit.${el}`),
        value: el
      }));
  const unitOptions = fieldValueUnits || [
    {
      name: 'YEAR',
      label: getTranslatedText(intl, 'ruleBuilder.value.label.year'),
      value: 'YEAR'
    },
    {
      name: 'MONTH',
      label: getTranslatedText(intl, 'ruleBuilder.value.label.month'),
      value: 'MONTH'
    },
    {
      name: 'WEEK',
      label: getTranslatedText(intl, 'ruleBuilder.value.label.week'),
      value: 'WEEK'
    },
    {
      name: 'DAY',
      label: getTranslatedText(intl, 'ruleBuilder.value.label.days'),
      value: 'DAY'
    },
    {
      name: 'HOUR',
      label: getTranslatedText(intl, 'ruleBuilder.value.label.hours'),
      value: 'HOUR'
    },
    {
      name: 'MINUTE',
      label: getTranslatedText(intl, 'ruleBuilder.value.label.minutes'),
      value: 'MINUTE'
    }
  ];
  const [options, setOptions] = useState(initialOptions);
  const [asyncOptions, setAsyncOptions] = useState({});

  useEffect(() => {
    if (async && values?.then) {
      values.then((res) => {
        if (Array.isArray(res)) {
          setOptions(res);
        } else {
          setAsyncOptions(res);
        }
      });
    }
  }, [async, values]);

  if (!type || !operator || operator === 'null' || operator === 'notNull') {
    return null;
  }
  let parsedValue = _.cloneDeep(value);
  let displayValue = undefined;

  if (typeof parsedValue === 'object' && parsedValue.length) {
    console.log(options);
    parsedValue = value.map((el) => {
      const selectedOption = options?.find((v) => v.name === el) || {};
      return {
        name: selectedOption.name || el,
        label: selectedOption.label || el,
        value: selectedOption.name || el
      };
    });
  }

  if (type === 'boolean_select') {
    if (typeof parsedValue === 'boolean') {
      displayValue = {
        name: String(parsedValue),
        label: String(parsedValue),
        value: String(parsedValue)
      };
    }
  }

  const allOptions = options.map((item) => {
    if (item.label === value || item.name === value) {
      displayValue = item;
    }
    return {
      ...item,
      value: item.name
    };
  });

  const groupOptionsIfNeeded = (items) => {
    if (!getValueGroupAccessor) return items;
    const grouped = {};

    items.forEach((opt) => {
      const key = getValueGroupAccessor(opt.original, field);
      const groupKey = key == null ? 'Others' : key;
      if (!grouped[groupKey]) grouped[groupKey] = [];
      grouped[groupKey].push(opt);
    });

    return Object.keys(grouped).map((groupKey) => {
      const label = getCustomGroupValueLabel
        ? getCustomGroupValueLabel(groupKey, field)
        : groupKey;
      return { label, options: grouped[groupKey] };
    });
  };

  const indicatorSeparatorStyle = {
    width: 0
  };

  const IndicatorSeparator = ({ innerProps }) => {
    return <span style={indicatorSeparatorStyle} {...innerProps} />;
  };

  const loadOptions = (inputValue, callback) => {
    if (inputValue.length < 2) return callback([]);
    fetchValues(asyncOptions.client, asyncOptions.query, {
      inputValue,
      field
    }).then((res) => {
      return callback(groupOptionsIfNeeded(res));
    });
  };

  const loadOptionsDebounce = debounce(loadOptions, 500);

  const handleSelectChange = (value, type) => {
    if (type === 'boolean_select') {
      handleOnChange(value.name === 'true');
    } else {
      handleOnChange(value);
    }
  };

  const handleOnMultiSelectTextChange = (type, value) => {
    if (type === 'multi_select_text') {
      handleOnChange(
        value.map((el) => {
          return {
            name: el,
            label: el,
            value: el
          };
        })
      );
    }
  };

  const getMultiSelectTextDefaultValue = () => {
    if (!isEmpty(parsedValue)) {
      return parsedValue.map((el) => {
        return el.name;
      });
    }
    return parsedValue;
  };

  switch (type) {
    case 'select':
    case 'boolean_select':
      return (
        <>
          <Select
            isDisabled={disabled}
            className={`${className}`}
            classNamePrefix="value_selector"
            //value={value === '' ? '' : options.find(el => el.label == value.label)}
            value={displayValue}
            components={{ IndicatorSeparator, DropdownIndicator }}
            title={title}
            onChange={(selected) => handleSelectChange(selected, type)}
            options={groupOptionsIfNeeded(allOptions)}
            placeholder="Choose value"
            menuPortalTarget={document.body}
            menuPlacement="auto"
            closeMenuOnScroll={(e) => {
              return (
                e.target &&
                e.target.classList &&
                !(e.target.classList.value.indexOf('menu-list') > -1)
              );
            }}
            name="valueselector"
            styles={
              errors
                ? {
                    menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                    menu: (base) => ({ ...base, zIndex: 9999 }),
                    ...reactSelectErrorStyles
                  }
                : {
                    menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                    menu: (base) => ({ ...base, zIndex: 9999 })
                  }
            }
            formatGroupLabel={formatGroupLabel}
            formatOptionLabel={formatOptionLabel}
          />
          {errors && reactSelectInlineError(errors[0])}
        </>
      );

    case 'multi_select_text':
      return (
        <MultiTextField
          disabled={disabled}
          onItemAdded={(item, allItems) => {
            handleOnMultiSelectTextChange(type, allItems);
          }}
          onItemDeleted={(item, allItems) => {
            handleOnMultiSelectTextChange(type, allItems);
          }}
          label=""
          name="item-input"
          values={getMultiSelectTextDefaultValue()}
          placeholder="type and press enter"
          addHelper={false}
        />
      );

    case 'multiselect':
      return (
        <>
          <Select
            disabled={disabled}
            className={`${className}`}
            classNamePrefix="value_selector"
            //value={value === '' ? '' : options.find(el => el.label == value.label)}
            value={parsedValue}
            components={{ IndicatorSeparator, DropdownIndicator }}
            title={title}
            onChange={(selected) => handleOnChange(selected)}
            options={groupOptionsIfNeeded(allOptions)}
            placeholder="Choose value"
            menuPortalTarget={document.body}
            menuPlacement="auto"
            closeMenuOnScroll={(e) => {
              return (
                e.target &&
                e.target.classList &&
                !(e.target.classList.value.indexOf('menu-list') > -1)
              );
            }}
            isMulti
            name="valueselector"
            styles={
              errors
                ? {
                    menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                    menu: (base) => ({ ...base, zIndex: 9999 }),
                    ...reactSelectErrorStyles
                  }
                : {
                    menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                    menu: (base) => ({ ...base, zIndex: 9999 })
                  }
            }
            formatGroupLabel={formatGroupLabel}
            formatOptionLabel={formatOptionLabel}
          />
          {errors && reactSelectInlineError(errors[0])}
        </>
      );
    case 'checkbox':
      return (
        <input
          disabled={disabled}
          type="checkbox"
          className={className}
          title={title}
          onChange={(e) => handleOnChange(e.target.checked)}
          checked={!!value}
        />
      );

    case 'radio':
      return (
        <span className={className} title={title}>
          {values.map((v) => (
            <label key={v.name}>
              <input
                disabled={disabled}
                type="radio"
                value={v.name}
                checked={value === v.name}
                onChange={(e) => handleOnChange(e.target.value)}
              />
              {v.label}
            </label>
          ))}
        </span>
      );

    case 'search_select':
    case 'multi_search_select':
      return (
        <>
          <AsyncSelect
            disabled={disabled}
            isMulti={type === 'multi_search_select'}
            cacheOptions
            defaultValue={
              type === 'multi_search_select'
                ? parsedValue
                : parsedValue
                ? { value: parsedValue, label: parsedValue }
                : ''
            }
            className={`${className}`}
            classNamePrefix="value_selector"
            placeholder={getTranslatedText(intl, 'app.rulebuilder.placeholder')}
            loadOptions={loadOptionsDebounce}
            onChange={(val) => {
              handleOnChange(val);
            }}
            components={{ IndicatorSeparator, DropdownIndicator }}
            closeMenuOnScroll={(e) => {
              return (
                e.target &&
                e.target.classList &&
                !(e.target.classList.value.indexOf('menu-list') > -1)
              );
            }}
            name="valueselector"
            menuPortalTarget={document.body}
            styles={
              errors
                ? {
                    menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                    menu: (base) => ({ ...base, zIndex: 9999 }),
                    ...reactSelectErrorStyles
                  }
                : {
                    menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                    menu: (base) => ({ ...base, zIndex: 9999 })
                  }
            }
            noOptionsMessage={(params) => {
              return params?.inputValue?.length < 2
                ? 'Type 2 or more characters to search'
                : 'No options';
            }}
            formatGroupLabel={formatGroupLabel}
            formatOptionLabel={formatOptionLabel}
          />
        </>
      );

    case 'unit':
      return (
        <div className="flex">
          <TextField
            disabled={disabled}
            value={value.quantity}
            title={title}
            onChange={(val) => {
              let updatedVal = val || '';
              if (updatedVal?.includes('.')) {
                updatedVal = updatedVal.replace('.', '');
              }
              const obj = {};
              obj.unit = value.unit || 'DAY';
              obj.quantity = updatedVal || '';
              handleOnChange({ name: obj });
            }}
            placeholder="Enter Text"
            type={inputType || 'text'}
            className={`${className} rule-text-field`}
            error={errors?.[0]}
          />
          <Select
            disabled={disabled}
            className={`${className} rule-unit-selection`}
            classNamePrefix="value_selector"
            //value={value === '' ? '' : options.find(el => el.label == value.label)}
            value={
              unitOptions.find((el) => el.name === value?.unit) ||
              unitOptions.find((el) => el.name === 'DAY')
            }
            components={{ IndicatorSeparator, DropdownIndicator }}
            title={title}
            onChange={(val) => {
              const obj = {};
              obj.unit = val.name || 'DAY';
              obj.quantity = value.quantity || '';
              handleOnChange({ name: obj });
            }}
            options={unitOptions}
            placeholder={'Choose value'}
            menuPortalTarget={document.body}
            menuPlacement="auto"
            closeMenuOnScroll={(e) => {
              return (
                e.target &&
                e.target.classList &&
                !(e.target.classList.value.indexOf('menu-list') > -1)
              );
            }}
            name="valueselector"
            styles={
              errors
                ? {
                    menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                    ...reactSelectErrorStyles
                  }
                : { menuPortal: (base) => ({ ...base, zIndex: 9999 }) }
            }
          />
        </div>
      );
    case 'dual_text_field': {
      const startValue = value?.[0]?.name || value?.[0] || '';
      const endValue = value?.[1]?.name || value?.[1] || '';
      const hasValidationError = errors?.[0];
      const startError =
        hasValidationError ||
        (endValue &&
          !startValue &&
          getTranslatedText(intl, 'dromo.validation.requiredField'));
      const endError =
        hasValidationError ||
        (startValue &&
          !endValue &&
          getTranslatedText(intl, 'dromo.validation.requiredField'));
      return (
        <div className="flex g20">
          <TextField
            disabled={disabled}
            value={startValue}
            title={title}
            onChange={(val) => {
              const end = value?.[1]?.name || value?.[1] || '';
              handleOnChange([{ name: val }, { name: end }]);
            }}
            placeholder="Enter Text"
            type={inputType || 'text'}
            className={`${className} rule-text-field`}
            error={startError}
          />
          <TextField
            disabled={disabled}
            value={endValue}
            title={title}
            onChange={(val) => {
              const start = value?.[0]?.name || value?.[0] || '';
              handleOnChange([{ name: start }, { name: val }]);
            }}
            placeholder="Enter Text"
            type={inputType || 'text'}
            className={`${className} rule-text-field`}
            error={endError}
          />
        </div>
      );
    }
    case 'dual_date_picker':
      return (
        <div className="flex">
          <DatePicker
            disabled={disabled}
            selected={value?.[0] && dayjs(value[0]).toDate()}
            onChange={(date) => {
              const formattedValue = dayjs(date).format('YYYY-MM-DD');
              const end = value?.[1] || '';
              handleOnChange([{ name: formattedValue }, { name: end }]);
            }}
            dateFormat="yyyy-MM-dd"
            selectsStart
            startDate={value?.[0] && dayjs(value[0]).toDate()}
            endDate={value?.[1] && dayjs(value[1]).toDate()}
            placeholderText="YYYY-MM-DD"
          />
          <DatePicker
            disabled={disabled}
            selected={value?.[1] && dayjs(value[1]).toDate()}
            onChange={(date) => {
              const formattedValue = dayjs(date).format('YYYY-MM-DD');
              const start = value?.[0] || '';
              handleOnChange([{ name: start }, { name: formattedValue }]);
            }}
            dateFormat="yyyy-MM-dd"
            selectsEnd
            startDate={value?.[0] && dayjs(value[0]).toDate()}
            endDate={value?.[1] && dayjs(value[1]).toDate()}
            minDate={value?.[0] && dayjs(value[0]).toDate()}
            placeholderText="YYYY-MM-DD"
            openToDate={new Date()}
          />
        </div>
      );
    case 'datepicker':
      return (
        <DatePicker
          disabled={disabled}
          selected={value && dayjs(value).toDate()}
          onChange={(date) => {
            const formattedValue = dayjs(date).format('YYYY-MM-DD');
            handleOnChange(formattedValue);
          }}
          placeholderText="YYYY-MM-DD"
          dateFormat="yyyy-MM-dd"
        />
      );
    case 'dual_datatime_picker':
      return (
        <div className="flex">
          <DatePicker
            disabled={disabled}
            selected={value?.[0] && dayjs(value[0]).toDate()}
            onChange={(date) => {
              const formattedValue = dayjs(date).format('YYYY-MM-DDTHH:mm:ss');
              const end = value?.[1] || '';
              handleOnChange([{ name: formattedValue }, { name: end }]);
            }}
            selectsStart
            startDate={value?.[0] && dayjs(value[0]).toDate()}
            endDate={value?.[1] && dayjs(value[1]).toDate()}
            placeholderText="YYYY-MM-DD"
            dateFormat="yyyy-MM-dd h:mm aa"
            showTimeInput
            portalId="root-portal"
          />
          <DatePicker
            selected={value?.[1] && dayjs(value[1]).toDate()}
            onChange={(date) => {
              const formattedValue = dayjs(date).format('YYYY-MM-DDTHH:mm:ss');
              const start = value?.[0] || '';
              handleOnChange([{ name: start }, { name: formattedValue }]);
            }}
            selectsEnd
            startDate={value?.[0] && dayjs(value[0]).toDate()}
            endDate={value?.[1] && dayjs(value[1]).toDate()}
            minDate={value?.[0] && dayjs(value[0]).toDate()}
            placeholderText="YYYY-MM-DD"
            dateFormat="yyyy-MM-dd h:mm aa"
            showTimeInput
            portalId="root-portal"
            openToDate={new Date()}
            disabled={disabled}
          />
        </div>
      );
    case 'datetime_picker':
      return (
        <DatePicker
          selected={value && dayjs(value).toDate()}
          onChange={(date) => {
            const formattedValue = dayjs(date).format('YYYY-MM-DDTHH:mm:ss');
            handleOnChange(formattedValue);
          }}
          placeholderText="YYYY-MM-DD"
          dateFormat="yyyy-MM-dd h:mm aa"
          showTimeInput
          portalId="root-portal"
          disabled={disabled}
        />
      );
    case 'date_options_select':
      return (
        <Select
          disabled={disabled}
          className={`${className}`}
          key={value}
          classNamePrefix="value_selector"
          formatGroupLabel={formatGroupLabel}
          formatOptionLabel={formatOptionLabel}
          value={allOptions.find((el) => el.key === value)}
          components={{ IndicatorSeparator, DropdownIndicator }}
          onChange={(val) => {
            handleOnChange(val);
          }}
          options={allOptions}
          placeholder="Choose value"
          menuPortalTarget={document.body}
          menuPlacement="auto"
          closeMenuOnScroll={(e) => {
            e.stopPropagation();
            e.preventDefault();
            return (
              e.target &&
              e.target.classList &&
              !(e.target.classList.value.indexOf('menu-list') > -1)
            );
          }}
          styles={{ menuPortal: (base) => ({ ...base, zIndex: 9999 }) }}
        />
      );

    default:
      return (
        <TextField
          disabled={disabled}
          value={value}
          title={title}
          onChange={(val) => {
            handleOnChange(val);
          }}
          placeholder="Enter Text"
          type={inputType || 'text'}
          className={`${className} rule-text-field`}
          error={errors?.[0]}
        />
      );
  }
};

ValueEditor.displayName = 'ValueEditor';

ValueEditor.propTypes = {
  field: PropTypes.string,
  operator: PropTypes.string,
  value: PropTypes.any,
  handleOnChange: PropTypes.func,
  title: PropTypes.string,
  className: PropTypes.string,
  type: PropTypes.string,
  inputType: PropTypes.string,
  values: PropTypes.arrayOf(PropTypes.object),
  getValueGroupAccessor: PropTypes.func,
  getCustomGroupValueLabel: PropTypes.func
};

export default injectIntl(ValueEditor);
